import React from 'react';
import PropTypes from 'prop-types';

const PersonalDetails = ({ items }) => (
  <dl className="personal-details">
    {items.map(detail => (
      <React.Fragment key={detail.id}>
        <dt>{detail.tag}</dt>
        <dd>{detail.detail}</dd>
      </React.Fragment>
    ))}
  </dl>
);

PersonalDetails.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.exact({
      id: PropTypes.string,
      tag: PropTypes.string,
      detail: PropTypes.string
    })
  )
};

PersonalDetails.defaultProps = {
  items: []
};

export default PersonalDetails;
